import {
  Avatar,
  Box,
  Collapse,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { noConflict } from "lodash";
import React from "react";
import {
  StyledTableCell,
  StyledTableCellBodyBold,
  StyledTableRow,
} from "../../../components/CustomStyles/CustomTable";
import Img from "../../../components/Img";
import moment from "moment-timezone";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";
import { formatCurrency } from "../../../components/Utils/Currency";
import { StyledButton } from "../../../components/CustomStyles/CustomButton";
import { Skeleton } from "@material-ui/lab";
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import { QRCodeIcon } from "../../../components/IconAssets";

const ListLoadingOrder = (props) => {
  return (
    <StyledTableRow>
      <StyledTableCell>
        <Skeleton height={20} />
      </StyledTableCell>
      <StyledTableCell>
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Skeleton height={40} width={40} />
            </ListItemAvatar>
            <ListItemText primary={<Skeleton height={16} />} />
          </ListItem>
        </List>
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton height={16} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton height={16} />
      </StyledTableCell>
      <StyledTableCell>
        <Skeleton height={16} />
      </StyledTableCell>
      <StyledTableCell align="right">
        <Skeleton height={20} />
      </StyledTableCell>
    </StyledTableRow>
  );
};

const ListOrder = (props) => {
  const {
    action,
    access,
    no,
    transaction,
    order,
    handleUpdateRunner,
    handleShowQR,
  } = props;
  const [openRow, setOpenRow] = React.useState(false);
  const unique_id = transaction.unique_id;
  const tenant = order.tenant;
  const pickup = transaction.pickup;
  return (
    <React.Fragment>
      <StyledTableRow onClick={() => setOpenRow(!openRow)}>
        <StyledTableCell>{no}</StyledTableCell>
        <StyledTableCell>
          <List style={{ padding: 0 }}>
            <ListItem style={{ padding: 0 }}>
              <ListItemAvatar>
                <Avatar variant="square" style={{ boxShadow: "none" }}>
                  <Img
                    src={tenant?.logo.square}
                    width={40}
                    height={40}
                    alt={tenant?.name}
                  />
                </Avatar>
              </ListItemAvatar>
              <ListItemText primary={tenant?.name} />
            </ListItem>
          </List>
        </StyledTableCell>
        <StyledTableCell>{pickup?.name}</StyledTableCell>
        <StyledTableCell>
          <span className="d-block font-bold font-14">{transaction?.user?.name}</span>
          <span className="font-12">{transaction?.unique_id}</span>
        </StyledTableCell>
        <StyledTableCell>
          {moment(transaction.create_time)
            .tz(tenant?.property?.timezone)
            .format("MMM Do YYYY, HH:mm:ss z")}
        </StyledTableCell>
        <StyledTableCell align="right">
          <IconButton
            color="secondary"
            onClick={() => setOpenRow(!openRow)}
            aria-label="show detail"
          >
            {openRow ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
          </IconButton>
        </StyledTableCell>
      </StyledTableRow>
      <StyledTableRow>
        <StyledTableCell colSpan={7} style={{ padding: 0, border: "none" }}>
          <Collapse
            in={openRow}
            timeout="auto"
            unmountOnExit
            style={{ backgroundColor: "#F5F5F5", padding: 16 }}
          >
            <Box
              margin={0}
              style={{ width: "100%", backgroundColor: "#F5F5F5" }}
            >
              <Table size="small" aria-label="detail order">
                <TableHead>
                  <TableRow>
                    <StyledTableCellBodyBold
                      style={{
                        backgroundColor: "#2196F3",
                        color: "#ffffff",
                      }}
                    >
                      Item
                    </StyledTableCellBodyBold>
                    <StyledTableCellBodyBold
                      style={{
                        backgroundColor: "#2196F3",
                        color: "#ffffff",
                      }}
                    >
                      Qty/Note
                    </StyledTableCellBodyBold>
                    <StyledTableCellBodyBold
                      align="right"
                      style={{
                        backgroundColor: "#2196F3",
                        color: "#ffffff",
                      }}
                    >
                      Price
                    </StyledTableCellBodyBold>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {order.items
                    ? order.items.map((item, i) => {
                        return (
                          <TableRow key={i}>
                            <TableCell>{item.name || ""}</TableCell>
                            <TableCell>
                              {item.qty} x (
                              {formatCurrency(
                                tenant?.property?.currency,
                                (item.discounted_price
                                  ? item.discounted_price
                                  : item.price.value
                                ).toString()
                              )}
                              )
                            </TableCell>
                            <TableCell align="right">
                              {formatCurrency(
                                tenant?.property?.currency,
                                (
                                  item.qty *
                                  (item.discounted_price
                                    ? item.discounted_price
                                    : item.price.value)
                                ).toString()
                              )}
                              {item.note && (
                                <React.Fragment>
                                  <br />
                                  <span
                                    style={{
                                      fontStyle: "italic",
                                      lineHeight: 2,
                                    }}
                                  >
                                    {item.note}
                                  </span>
                                </React.Fragment>
                              )}
                            </TableCell>
                          </TableRow>
                        );
                      })
                    : ""}
                  <TableRow>
                    <StyledTableCellBodyBold colSpan={2}>
                      Sub Total
                    </StyledTableCellBodyBold>
                    <StyledTableCellBodyBold align="right">
                      {formatCurrency(
                        tenant?.property?.currency,
                        (
                          order.sub_total_amount -
                          order.service_charge_amount -
                          order.tax_charge_amount
                        ).toString()
                      )}
                    </StyledTableCellBodyBold>
                  </TableRow>
                  <TableRow>
                    <StyledTableCellBodyBold colSpan={2}>
                      Service ({tenant.service_charge_percentage}%)
                    </StyledTableCellBodyBold>
                    <StyledTableCellBodyBold align="right">
                      {formatCurrency(
                        tenant?.property?.currency,
                        order.service_charge_amount.toString()
                      )}
                    </StyledTableCellBodyBold>
                  </TableRow>
                  <TableRow>
                    <StyledTableCellBodyBold colSpan={2}>
                      Tax ({tenant.tax_charge_percentage}%)
                    </StyledTableCellBodyBold>
                    <StyledTableCellBodyBold align="right">
                      {formatCurrency(
                        tenant?.property?.currency,
                        order.tax_charge_amount.toString()
                      )}
                    </StyledTableCellBodyBold>
                  </TableRow>
                  <TableRow>
                    <StyledTableCellBodyBold
                      colSpan={3}
                      align="right"
                      style={{ fontSize: "larger", color: "#4CAF50" }}
                    >
                      Total:{" "}
                      {formatCurrency(
                        tenant?.property?.currency,
                        (order.sub_total_amount || 0).toString()
                      )}
                    </StyledTableCellBodyBold>
                  </TableRow>
                </TableBody>
              </Table>
              {access.patch === true && (
                <Grid
                  item
                  xs={12}
                  style={{
                    backgroundColor: "#F5F5F5",
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                  }}
                >
                  {action.status === "complete" ? (
                    <StyledButton
                      size="small"
                      variant="contained"
                      style={{backgroundColor: "#4CAF50", color: "#000000", padding: 8}}
                      onClick={() => handleShowQR(unique_id, order, action)}
                    >
                      <span style={{marginRight: 10}}>{action.label_action}</span><img src={QRCodeIcon} alt="ic_qrcode" style={{width: 22, height: 22}} />
                    </StyledButton>
                  ) : (
                    <StyledButton
                      size="small"
                      variant="contained"
                      style={{backgroundColor: "#FF9800", color: "#000000"}}
                      onClick={() => handleUpdateRunner(order, action, true)}
                    >
                      <span style={{marginRight: 10}}>{action.label_action}</span><ArrowForwardIcon />
                    </StyledButton>
                  )}
                </Grid>
              )}
            </Box>
          </Collapse>
        </StyledTableCell>
      </StyledTableRow>
    </React.Fragment>
  );
};

export { ListOrder, ListLoadingOrder };
